.ao{aspect-ratio:1/1;}